// import $ from 'jquery';
import { getClientId } from '../../selectors/client';
// import isNil from 'lodash/isNil';
import store from '../../store';

const requestInterceptor = config => ({
  ...config,
  // data:
  //   isNil(config.data) || typeof config.data === 'string'
  //     ? config.data
  //     : $.param(config.data),
  headers: {
    ...config.headers,
    common: {
      ...config.headers.common,
      'Client-Id': getClientId(store.getState()),
      Hostname: document.location.hostname,
    },
  },
});

export default requestInterceptor;
